import { render } from "./EditEmploymentStatus.vue?vue&type=template&id=4708b9a6"
import script from "./EditEmploymentStatus.vue?vue&type=script&lang=js"
export * from "./EditEmploymentStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__